import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IBulkEmployeesUpdateHistoryResponse } from '../models/bulk-employees-update-history.model';

export const getBulkEmployeesUpdateHistoryKey = 'getBulkEmployeesUpdateHistory';

export interface State {
  loadBulkEmployeesUpdateHistoryResponse: IBulkEmployeesUpdateHistoryResponse[];
  loadBulkEmployeesUpdateHistoryFailure: any;
  loaded: boolean;
}

export const initialState: State = {
  loadBulkEmployeesUpdateHistoryResponse: undefined,
  loadBulkEmployeesUpdateHistoryFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(actions.loadBulkEmployeesUpdateHistorySuccess, (state, action) => ({
    ...state,
    loadBulkEmployeesUpdateHistoryResponse: action.response,
    loaded: true
  })),

  on(actions.loadBulkEmployeesUpdateHistoryFailure, (state, action) => ({
    ...state,
    loadBulkEmployeesUpdateHistoryFailure: action.error
  }))
);

export const getBulkEmployeesUpdateHistory = (state: State) => state.loadBulkEmployeesUpdateHistoryResponse;
